// import React, { useRef, useEffect, useState } from "react";
// import PropTypes from "prop-types";
// import { Controller } from "react-hook-form";

// const InputAreaField = ({
//   name,
//   control,
//   label = "",
//   placeholder = "",
//   disabled = false,
//   inputRef,
//   defaultValue = "",
//   onChange,
//   onKeyDown,
//   autoComplete,
//   maxLength,
//   minRows = 2, // Minimum rows to start with
//   fontSize = "text-sm", // Default font size, matching others
//   inputSize = "h-auto", // For consistency with other components
//   // New props matching SearchDropdown
//   leftIcon,
//   rightIcon,
//   iconBgColor = "bg-gray-100",
//   inputBgColor = "bg-gray-50",
//   onLeftIconClick,
//   onRightIconClick,
//   // Floating label props
//   isFloatingLabel = true,
//   error,
//   ...rest
// }) => {
//   const textareaRef = useRef(null);
//   const [isFocused, setIsFocused] = useState(false);

//   const hasLeftIcon = leftIcon || false;
//   const hasRightIcon = rightIcon || false;

//   // Function to adjust height based on content
//   const adjustHeight = () => {
//     const textarea = textareaRef.current;
//     if (textarea) {
//       textarea.style.height = "auto"; // Reset height to auto to get accurate scrollHeight
//       const newHeight = Math.max(textarea.scrollHeight, minRows * 24); // Minimum height based on minRows
//       textarea.style.height = `${newHeight}px`; // Set height to match content
//     }
//   };

//   // Effect to adjust height on mount and value change
//   useEffect(() => {
//     adjustHeight();
//   }, []);

//   const getFontSizeClass = () => {
//     switch (fontSize) {
//       case "text-xs":
//         return "text-xs";
//       case "text-sm":
//         return "text-sm";
//       case "text-base":
//         return "text-base";
//       case "text-lg":
//         return "text-lg";
//       default:
//         return "text-sm";
//     }
//   };

//   const getHeightClass = () => {
//     // For textarea, we use min-height instead of fixed height
//     switch (inputSize) {
//       case "h-8":
//         return "min-h-8";
//       case "h-9":
//         return "min-h-9";
//       case "h-10":
//         return "min-h-10";
//       case "h-11":
//         return "min-h-11";
//       case "h-12":
//         return "min-h-12";
//       default:
//         return "min-h-0";
//     }
//   };

//   return (
//     <div className="relative w-full">
//       <Controller
//         name={name}
//         control={control}
//         defaultValue={defaultValue}
//         render={({ field, fieldState }) => {
//           // Use fieldState.error or passed error prop for validation errors
//           const hasError = Boolean(fieldState.error || error);
//           const hasValue = Boolean(field.value);

//           // Label should float when has value, focused, or typing (matching SearchDropdown logic)
//           const shouldFloatLabel = isFloatingLabel && (isFocused || hasValue);

//           return (
//             <>
//               {/* Floating Label (matching SearchDropdown) */}
//               {label && (
//                 <label
//                   htmlFor={name}
//                   className={`${
//                     isFloatingLabel
//                       ? `absolute transition-all duration-200 ease-in-out pointer-events-none z-10 ${
//                           shouldFloatLabel
//                             ? "top-0 text-xs scale-75 origin-top-left bg-white px-1"
//                             : "top-6 text-sm scale-100 origin-center"
//                         }`
//                       : "block mb-1"
//                   } ${getFontSizeClass()} ${
//                     hasError
//                       ? "text-red-500"
//                       : shouldFloatLabel
//                       ? "text-blue-600"
//                       : "text-gray-500"
//                   }`}
//                   style={
//                     isFloatingLabel
//                       ? {
//                           left: hasLeftIcon
//                             ? shouldFloatLabel
//                               ? "52px"
//                               : "52px"
//                             : shouldFloatLabel
//                             ? "14px"
//                             : "14px",
//                           transform: shouldFloatLabel
//                             ? "translateY(-50%) scale(0.75)"
//                             : "translateY(0) scale(1)",
//                           transformOrigin: "left top",
//                         }
//                       : {}
//                   }
//                 >
//                   {label}
//                 </label>
//               )}

//               <div className="relative">
//                 <div
//                   className={`relative flex items-stretch transition-all ${
//                     hasError
//                       ? "focus-within:ring-1 focus-within:ring-red-500 focus-within:ring-offset-0"
//                       : "focus-within:ring-1 focus-within:ring-blue-500 focus-within:ring-offset-0"
//                   } rounded-md`}
//                 >
//                   {/* Left Icon (matching SearchDropdown) */}
//                   {hasLeftIcon && (
//                     <div
//                       className={`flex items-start justify-center w-10 pt-3 ${iconBgColor} border border-r-0 ${
//                         hasError ? "border-red-500" : "border-gray-300"
//                       } rounded-l-md ${
//                         onLeftIconClick ? "cursor-pointer hover:opacity-80" : ""
//                       } ${
//                         disabled ? "opacity-50" : ""
//                       } transition-colors flex-shrink-0`}
//                       style={{ minWidth: "2.5rem", width: "2.5rem" }}
//                       onClick={onLeftIconClick}
//                     >
//                       {React.cloneElement(leftIcon, {
//                         className: `w-4 h-4 flex-shrink-0 ${
//                           leftIcon.props?.className || "text-gray-500"
//                         }`,
//                       })}
//                     </div>
//                   )}

//                   {/* Textarea Container (matching SearchDropdown structure) */}
//                   <div
//                     className={`flex flex-1 min-w-0 ${getHeightClass()} ${getFontSizeClass()} border ${inputBgColor} ${
//                       hasError ? "border-red-500" : "border-gray-300"
//                     } ${disabled ? "opacity-50 cursor-not-allowed" : ""} ${
//                       hasLeftIcon ? "rounded-l-none border-l-0" : "rounded-l-md"
//                     } ${
//                       hasRightIcon
//                         ? "rounded-r-none border-r-0"
//                         : "rounded-r-md"
//                     } focus-within:outline-none focus-within:ring-0 focus-within:border-transparent transition-colors`}
//                   >
//                     {/* Actual Textarea Field */}
//                     <textarea
//                       id={name}
//                       className={`w-full outline-none bg-transparent px-3 py-2 ${getFontSizeClass()} ${
//                         hasValue || isFocused
//                           ? "text-gray-800"
//                           : "text-gray-400"
//                       } resize-none overflow-hidden`}
//                       ref={(el) => {
//                         textareaRef.current = el; // Internal ref for height adjustment
//                         if (inputRef) inputRef.current = el; // External ref if provided
//                       }}
//                       {...field}
//                       placeholder={!shouldFloatLabel ? placeholder : ""}
//                       autoComplete={autoComplete}
//                       maxLength={maxLength}
//                       rows={minRows} // Minimum rows to start with
//                       onFocus={(e) => {
//                         setIsFocused(true);
//                         adjustHeight();
//                         if (rest.onFocus) rest.onFocus(e);
//                       }}
//                       onBlur={(e) => {
//                         setIsFocused(false);
//                         if (rest.onBlur) rest.onBlur(e);
//                       }}
//                       onChange={(e) => {
//                         field.onChange(e);
//                         adjustHeight(); // Adjust height on every change
//                         if (onChange) onChange(e);
//                       }}
//                       onKeyDown={(e) => {
//                         // Small delay to ensure content is updated before height adjustment
//                         setTimeout(() => adjustHeight(), 0);
//                         if (onKeyDown) onKeyDown(e);
//                       }}
//                       onInput={adjustHeight} // Additional height adjustment on input
//                       disabled={disabled}
//                       style={{
//                         minHeight: `${minRows * 1.5}rem`, // Minimum height based on minRows
//                       }}
//                       {...rest}
//                     />
//                   </div>

//                   {/* Right Icon (matching SearchDropdown) */}
//                   {hasRightIcon && (
//                     <div
//                       className={`flex items-start justify-center w-10 pt-3 ${iconBgColor} border border-l-0 ${
//                         hasError ? "border-red-500" : "border-gray-300"
//                       } rounded-r-md ${
//                         onRightIconClick
//                           ? "cursor-pointer hover:opacity-80"
//                           : ""
//                       } ${
//                         disabled ? "opacity-50" : ""
//                       } transition-colors flex-shrink-0`}
//                       style={{ minWidth: "2.5rem", width: "2.5rem" }}
//                       onClick={onRightIconClick}
//                     >
//                       {React.cloneElement(rightIcon, {
//                         className: `w-4 h-4 flex-shrink-0 ${
//                           rightIcon.props?.className || "text-gray-500"
//                         }`,
//                       })}
//                     </div>
//                   )}
//                 </div>
//               </div>

//               {/* Error Message (matching SearchDropdown) */}
//               {/* {hasError && (
//                 <p className="mt-1 text-sm text-red-600">
//                   {fieldState.error?.message ||
//                     error?.message ||
//                     "This field is required"}
//                 </p>
//               )} */}
//             </>
//           );
//         }}
//       />
//     </div>
//   );
// };

// InputAreaField.propTypes = {
//   name: PropTypes.string.isRequired,
//   control: PropTypes.object.isRequired,
//   label: PropTypes.string,
//   placeholder: PropTypes.string,
//   disabled: PropTypes.bool,
//   inputRef: PropTypes.object,
//   defaultValue: PropTypes.string,
//   onChange: PropTypes.func,
//   onKeyDown: PropTypes.func,
//   autoComplete: PropTypes.string,
//   maxLength: PropTypes.number,
//   minRows: PropTypes.number, // Minimum rows prop
//   fontSize: PropTypes.string,
//   inputSize: PropTypes.string,
//   leftIcon: PropTypes.element,
//   rightIcon: PropTypes.element,
//   iconBgColor: PropTypes.string,
//   inputBgColor: PropTypes.string,
//   onLeftIconClick: PropTypes.func,
//   onRightIconClick: PropTypes.func,
//   isFloatingLabel: PropTypes.bool,
//   error: PropTypes.object,
// };

// export default InputAreaField;


import React, { useRef, useEffect, useState, useCallback } from "react";
import PropTypes from "prop-types";
import { Controller } from "react-hook-form";
import { SpeechToTextWrapper } from "./speechToText";

const InputAreaField = ({
  name,
  control,
  label = "",
  placeholder = "",
  disabled = false,
  inputRef,
  defaultValue = "",
  onChange,
  onKeyDown,
  autoComplete,
  maxLength,
  minRows = 2,
  /** Alias for `minRows` — matches admission forms that pass `rows={2}` */
  rows: rowsProp,
  fontSize = "text-sm",
  inputSize = "h-auto",
  leftIcon,
  rightIcon,
  iconBgColor = "bg-gray-100",
  inputBgColor = "bg-gray-50",
  onLeftIconClick,
  onRightIconClick,
  isFloatingLabel = true,
  error,
  /** Mute/unmute mic dictation (Web Speech API — Chrome/Edge). */
  enableSpeechToText = false,
  /** E-pen / finger handwriting pad (insert as text or image). */
  enableHandwriting = false,
  /** Called with PNG data URL when user inserts handwriting as an image. */
  onHandwritingImage,
  ...rest
}) => {
  const textareaRef = useRef(null);
  const [isFocused, setIsFocused] = useState(false);

  const hasLeftIcon = leftIcon || false;
  const hasRightIcon = rightIcon || false;

  const effectiveMinRows =
    rowsProp != null && rowsProp !== ""
      ? Math.max(1, Number(rowsProp)) || minRows
      : minRows;

  // Auto-size function with useCallback to prevent unnecessary re-creation
  const adjustHeight = useCallback(() => {
    const textarea = textareaRef.current;
    if (!textarea) return;

    // Step 1: Reset height to auto to get accurate scrollHeight
    textarea.style.height = "auto";

    // Step 2: Calculate minimum height (minRows * 24px per row)
    const minHeight = effectiveMinRows * 24;

    // Step 3: Set height to content height or minimum, whichever is larger
    const newHeight = Math.max(textarea.scrollHeight, minHeight);
    textarea.style.height = `${newHeight}px`;
  }, [effectiveMinRows]);

  // Adjust height on mount
  useEffect(() => {
    adjustHeight();
  }, [adjustHeight]);

  const getFontSizeClass = () => {
    switch (fontSize) {
      case "text-xs":
        return "text-xs";
      case "text-sm":
        return "text-sm";
      case "text-base":
        return "text-base";
      case "text-lg":
        return "text-lg";
      default:
        return "text-sm";
    }
  };

  return (
    <div className="relative w-full">
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue}
        render={({ field, fieldState }) => {
          const hasError = Boolean(fieldState.error || error);
          const hasValue = Boolean(field.value);
          const shouldFloatLabel = isFloatingLabel && (isFocused || hasValue);

          return (
            <>
              {/* Floating Label */}
              {label && (
                <label
                  htmlFor={name}
                  className={`${
                    isFloatingLabel
                      ? `absolute transition-all duration-200 ease-in-out pointer-events-none z-10 ${
                          shouldFloatLabel
                            ? "top-0 text-xs scale-75 origin-top-left bg-white px-1"
                            : "top-1/2 text-sm scale-100 origin-center"
                        }`
                      : "block mb-1"
                  } ${getFontSizeClass()} ${
                    hasError
                      ? "text-red-500"
                      : shouldFloatLabel
                      ? "text-blue-600"
                      : "text-gray-500"
                  }`}
                  style={
                    isFloatingLabel
                      ? {
                          left: hasLeftIcon ? "52px" : "14px",
                          transform: shouldFloatLabel
                            ? "translateY(-50%) scale(0.75)"
                            : "translateY(-50%) scale(1)",
                          transformOrigin: shouldFloatLabel ? "left top" : "left center",
                        }
                      : {}
                  }
                >
                  {label}
                </label>
              )}

              <div className="relative">
                <div
                  className={`relative flex items-stretch transition-all ${
                    hasError
                      ? "focus-within:ring-1 focus-within:ring-red-500 focus-within:ring-offset-0"
                      : "focus-within:ring-1 focus-within:ring-blue-500 focus-within:ring-offset-0"
                  } rounded-md`}
                >
                  {/* Left Icon */}
                  {hasLeftIcon && (
                    <div
                      className={`flex items-start justify-center w-10 pt-3 ${iconBgColor} border border-r-0 ${
                        hasError ? "border-red-500" : "border-gray-300"
                      } rounded-l-md ${
                        onLeftIconClick ? "cursor-pointer hover:opacity-80" : ""
                      } ${
                        disabled ? "opacity-50" : ""
                      } transition-colors flex-shrink-0`}
                      style={{ minWidth: "2.5rem", width: "2.5rem" }}
                      onClick={onLeftIconClick}
                    >
                      {React.cloneElement(leftIcon, {
                        className: `w-4 h-4 flex-shrink-0 ${
                          leftIcon.props?.className || "text-gray-500"
                        }`,
                      })}
                    </div>
                  )}

                  {/* Textarea Container */}
                  {enableSpeechToText || enableHandwriting ? (
                    <SpeechToTextWrapper
                      value={field.value}
                      onChange={(v) => {
                        field.onChange(v);
                        setTimeout(() => adjustHeight(), 0);
                      }}
                      disabled={disabled}
                      micSize="sm"
                      className="flex flex-1 min-w-0"
                      enableSpeechToText={enableSpeechToText}
                      enableHandwriting={enableHandwriting}
                      onHandwritingImage={onHandwritingImage}
                    >
                      {({ speechPaddingClass }) => (
                        <div
                          className={`flex flex-1 min-w-0 ${getFontSizeClass()} border ${inputBgColor} ${
                            hasError ? "border-red-500" : "border-gray-300"
                          } ${disabled ? "opacity-50 cursor-not-allowed" : ""} ${
                            hasLeftIcon ? "rounded-l-none border-l-0" : "rounded-l-md"
                          } ${
                            hasRightIcon
                              ? "rounded-r-none border-r-0"
                              : "rounded-r-md"
                          } focus-within:outline-none focus-within:ring-0 focus-within:border-transparent transition-colors`}
                        >
                          <textarea
                            id={name}
                            className={`w-full outline-none bg-transparent px-3 py-2 ${speechPaddingClass} ${getFontSizeClass()} ${
                              hasValue || isFocused
                                ? "text-gray-800"
                                : "text-gray-400"
                            } resize-none overflow-y-scroll scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-100`}
                            ref={(el) => {
                              textareaRef.current = el;
                              if (inputRef) inputRef.current = el;
                            }}
                            value={field.value ?? ""}
                            placeholder={!shouldFloatLabel ? placeholder : ""}
                            autoComplete={autoComplete}
                            maxLength={maxLength}
                            onFocus={(e) => {
                              setIsFocused(true);
                              setTimeout(() => adjustHeight(), 0);
                              if (rest.onFocus) rest.onFocus(e);
                            }}
                            onBlur={(e) => {
                              setIsFocused(false);
                              if (rest.onBlur) rest.onBlur(e);
                            }}
                            onChange={(e) => {
                              field.onChange(e.target.value);
                              setTimeout(() => adjustHeight(), 0);
                              if (onChange) onChange(e);
                            }}
                            onKeyDown={(e) => {
                              setTimeout(() => adjustHeight(), 0);
                              if (onKeyDown) onKeyDown(e);
                            }}
                            onInput={adjustHeight}
                            disabled={disabled}
                            style={{
                              minHeight: `${effectiveMinRows * 24}px`,
                              height: "auto",
                              maxHeight: "500px",
                            }}
                          />
                        </div>
                      )}
                    </SpeechToTextWrapper>
                  ) : (
                    <div
                      className={`flex flex-1 min-w-0 ${getFontSizeClass()} border ${inputBgColor} ${
                        hasError ? "border-red-500" : "border-gray-300"
                      } ${disabled ? "opacity-50 cursor-not-allowed" : ""} ${
                        hasLeftIcon ? "rounded-l-none border-l-0" : "rounded-l-md"
                      } ${
                        hasRightIcon
                          ? "rounded-r-none border-r-0"
                          : "rounded-r-md"
                      } focus-within:outline-none focus-within:ring-0 focus-within:border-transparent transition-colors`}
                    >
                      <textarea
                        id={name}
                        className={`w-full outline-none bg-transparent px-3 py-2 ${getFontSizeClass()} ${
                          hasValue || isFocused
                            ? "text-gray-800"
                            : "text-gray-400"
                        } resize-none overflow-y-scroll scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-100`}
                        ref={(el) => {
                          textareaRef.current = el;
                          if (inputRef) inputRef.current = el;
                        }}
                        {...field}
                        placeholder={!shouldFloatLabel ? placeholder : ""}
                        autoComplete={autoComplete}
                        maxLength={maxLength}
                        onFocus={(e) => {
                          setIsFocused(true);
                          setTimeout(() => adjustHeight(), 0);
                          if (rest.onFocus) rest.onFocus(e);
                        }}
                        onBlur={(e) => {
                          setIsFocused(false);
                          if (rest.onBlur) rest.onBlur(e);
                        }}
                        onChange={(e) => {
                          field.onChange(e);
                          setTimeout(() => adjustHeight(), 0);
                          if (onChange) onChange(e);
                        }}
                        onKeyDown={(e) => {
                          setTimeout(() => adjustHeight(), 0);
                          if (onKeyDown) onKeyDown(e);
                        }}
                        onInput={adjustHeight}
                        disabled={disabled}
                        style={{
                          minHeight: `${effectiveMinRows * 24}px`,
                          height: "auto",
                          maxHeight: "500px",
                        }}
                      />
                    </div>
                  )}

                  {/* Right Icon */}
                  {hasRightIcon && (
                    <div
                      className={`flex items-start justify-center w-10 pt-3 ${iconBgColor} border border-l-0 ${
                        hasError ? "border-red-500" : "border-gray-300"
                      } rounded-r-md ${
                        onRightIconClick
                          ? "cursor-pointer hover:opacity-80"
                          : ""
                      } ${
                        disabled ? "opacity-50" : ""
                      } transition-colors flex-shrink-0`}
                      style={{ minWidth: "2.5rem", width: "2.5rem" }}
                      onClick={onRightIconClick}
                    >
                      {React.cloneElement(rightIcon, {
                        className: `w-4 h-4 flex-shrink-0 ${
                          rightIcon.props?.className || "text-gray-500"
                        }`,
                      })}
                    </div>
                  )}
                </div>
              </div>
            </>
          );
        }}
      />

      {/* Custom Scrollbar Styles */}
      <style>{`
        #${name}::-webkit-scrollbar {
          width: 8px;
        }

        #${name}::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 4px;
        }

        #${name}::-webkit-scrollbar-thumb {
          background: #888;
          border-radius: 4px;
        }

        #${name}::-webkit-scrollbar-thumb:hover {
          background: #555;
        }
      `}</style>
    </div>
  );
};

InputAreaField.propTypes = {
  name: PropTypes.string.isRequired,
  control: PropTypes.object.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  inputRef: PropTypes.object,
  defaultValue: PropTypes.string,
  onChange: PropTypes.func,
  onKeyDown: PropTypes.func,
  autoComplete: PropTypes.string,
  maxLength: PropTypes.number,
  minRows: PropTypes.number,
  rows: PropTypes.number,
  fontSize: PropTypes.string,
  inputSize: PropTypes.string,
  leftIcon: PropTypes.element,
  rightIcon: PropTypes.element,
  iconBgColor: PropTypes.string,
  inputBgColor: PropTypes.string,
  onLeftIconClick: PropTypes.func,
  onRightIconClick: PropTypes.func,
  isFloatingLabel: PropTypes.bool,
  error: PropTypes.object,
  enableSpeechToText: PropTypes.bool,
  enableHandwriting: PropTypes.bool,
  onHandwritingImage: PropTypes.func,
};

export default InputAreaField;
